import React, { Component } from 'react';
import { Big3Common, bootstrap } from '../../../js/IncludeManager'
import { Alert, ComboBox } from "../../../js/ComponentManager";
/* 개발담당:양유빈
 * 화면기능:사입팀 매칭
 * 세부설명: retail_mgt의 appr_status 값이 '01','02','03' 인것들만 관리 되며, 
 * 사입자를 추가 또는 변경 할려면 retail_mgt에 등록된 모든 appr_status의 값이 '04'(미사용) 인 상태가 되어야 등록 될 수 있음. 
*/

export class TeamMatching extends Component {
    static displayName = TeamMatching.name;

    constructor(props) {
        super(props);
        this.state = {
            SsList: [],
            TsList: [],
            TsCombo: [],
            BuyerPhone: "",
            Title: "",
            Content: "",
            Buyer_Uid: "",
            Buyer_Org_Name: "",
            Buyer_Name:"",
            Area_Name: "",
            Buyer_Type: ""
        };
        this.handle_Change = this.handle_Change.bind(this);
        this.handleBuyerSearch_Click = this.handleBuyerSearch_Click.bind(this);
        this.handleSave_Click = this.handleSave_Click.bind(this);
        this.handleCombo_Change = this.handleCombo_Change.bind(this);
        this.handleWithdraw_Click = this.handleWithdraw_Click.bind(this);
        this.Uid_Type = Big3Common.WebStorage.GetLocalStorage(Big3Common.WebStorage.StorageName.Uid_Type)
        this.TempTsList = [];
    }
    //초기화
    componentDidMount() {
        this.CallRetailMgtListData();
        this.GetTsCombo();
        this.GetTsList();
    }
    //사입자 리스트 조회
    async CallRetailMgtListData() {
        try {
            let Data = await Big3Common.Get('api/MyPage/StoreMgr/GetRetailMgtList');
            if (Data.codeName === Big3Common.ResultCode.Success) {
                const SsList = JSON.parse(Data.dataTable)
                this.setState({ SsList: SsList });
                if (SsList.filter(list => list.appr_status === "01" || list.appr_status === "02" || list.appr_status === "03").length === 0 &&
                    Big3Common.WebStorage.GetLocalStorage(Big3Common.WebStorage.StorageName.Uid_Type) === 'SS') {
                    Big3Common.WebStorage.RemoveStorage(Big3Common.WebStorage.StorageName.Uid_Type);
                    this.Uid_Type = "";
                }
            }
        }
        catch (e) {
            console.log("CallRetailMgtListData", e);
        }
    }
    //택배삼촌 리스트
    async GetTsList() {
        try {
            let Data = await Big3Common.Post('api/MyPage/StoreMgr/GetTsList', {}, true);
            if (Data.codeName === Big3Common.ResultCode.Success) {
                this.setState({ TsList: JSON.parse(Data.dataTable) });
            }
        }
        catch (e) {
            console.log("GetTsList", e);
        }
    }
    //택배삼촌 콤보
    async GetTsCombo() {
        try {
            let Data = await Big3Common.Post('api/MyPage/StoreMgr/GetTsCombo', { }, true);
            if (Data.codeName === Big3Common.ResultCode.Success) {
                this.setState({ TsCombo: JSON.parse(Data.dataTable) });
            }
        }
        catch (e) {
            console.log("GetTsCombo", e);
        }
    }
    handle_Change(event, MaxLength = 20) {

        const value = event.target.value.trim();
        const StringText = value.replace(/-/gi, '');
        const StringLength = StringText.length;

        if (Big3Common.Util.isNumber(StringText) === false) {
            return false;
        }
        if (StringLength > MaxLength) {
            return false;
        }
        this.setState({ BuyerPhone: value });
        event.preventDefault();
    }
    //택배삼촌 선택
    async handleCombo_Change(event) {
        const value = event.target.value
        try {
            Big3Common.Util.LoadingOn();
            let Data = await Big3Common.Post('api/MyPage/StoreMgr/GetTsCombo', { Buyer_Uid: value }, true);
            if (Data.codeName === Big3Common.ResultCode.Success) {
                const TempTsList = JSON.parse(Data.dataTable);
                if (TempTsList.length > 0) {
                    this.setState({
                        Buyer_Uid: TempTsList[0].buyer_uid,
                        Buyer_Org_Name: TempTsList[0].buyer_org_name,
                        Buyer_Name: TempTsList[0].buyer_name
                    });
                    this.TempTsList = TempTsList
                }
                else {
                    this.setState({
                        Buyer_Uid: "",
                        Buyer_Org_Name: "",
                        Buyer_Name: ""
                    });
                    this.TempTsList = []
                }
            }
            else {
                this.setState({ Title: Data.message });
                Big3Common.ModalAlert(bootstrap, "MessageAlert");
            }
        }
        catch (e) {
            console.log("handleCombo_Change", e);
        }
        finally {
            Big3Common.Util.LoadingOff();
        }
        event.preventDefault();
    }
    //사입자 검색
    async handleBuyerSearch_Click(event) {
        
        const BuyerPhone = this.state.BuyerPhone;
        if (BuyerPhone.length === 0) {
            this.setState({ Title: "핸드폰번호를 입력하여 주세요.", Content: " " });
            Big3Common.ModalAlert(bootstrap, "MessageAlert");
            return false;
        }
        const isCheck = Big3Common.Util.HandPhoneCheck(BuyerPhone);
        if (!isCheck) {
            this.setState({ Title: "핸드폰번호 형식이 잘못 되었습니다", Content: " " });
            Big3Common.ModalAlert(bootstrap, "MessageAlert");
            return false;
        }
        try {
            Big3Common.Util.LoadingOn();
            const hpFormat = Big3Common.Util.HandPhoneFormat(this.state.BuyerPhone);
            let Data = await Big3Common.Post('api/Account/MemberMgr/GetBuyerInfo', { BuyerPhone: hpFormat }, true);
            if (Data.codeName === Big3Common.ResultCode.Success) {
                const Info = JSON.parse(Data.dataTable);
                if (Info.length > 0) {
                    this.setState({
                        Buyer_Uid: Info[0].buyer_uid,
                        Buyer_Org_Name: Info[0].buyer_org_name,
                        Buyer_Name: Info[0].buyer_name,
                        Area_Name: `(${Info[0].area_name})`
                    });
                }
                else {
                    this.setState({ Title: "사입자 정보가 없습니다.", Content: " " });
                    Big3Common.ModalAlert(bootstrap, "MessageAlert");
                }
            }
            else {
                this.setState({ Title: Data.message });
                Big3Common.ModalAlert(bootstrap, "MessageAlert");
            }
        }
        catch (e) {
            console.log("handleBuyerSearch_Click", e);
        }
        finally {
            Big3Common.Util.LoadingOff();
        }
        event.preventDefault();
    }
    //사입자 등록
    async handleSave_Click(event) {
        let TempTsList = this.TempTsList
        let Buyer_Uid = this.state.Buyer_Uid
        if (TempTsList.length > 0 || Buyer_Uid !== '') {
            try {
                let Data = await Big3Common.Post('api/MyPage/StoreMgr/RegisterRetailMgt', {
                    Buyer_Uid: this.state.Buyer_Uid,
                    Buyer_Type: this.state.Buyer_Type
                }, true);
                if (Data.codeName === Big3Common.ResultCode.Success) {
                    if (this.state.Buyer_Type === 'SS') {
                        this.setState({
                            Title: "등록안내",
                            Content: "정상적으로 등록되었습니다.\n해당 사입자가 거래 승인 후 사용하실 수 있습니다."
                        });
                    } else if (this.state.Buyer_Type === 'TS') {
                        this.setState({
                            Title: "등록안내",
                            Content: "정상적으로 등록되었습니다."
                        });
                    }
                    Big3Common.ModalAlert(bootstrap, "MessageAlert");
                    Big3Common.WebStorage.SetLocalStorage(Big3Common.WebStorage.StorageName.Uid_Type, this.state.Buyer_Type);
                    this.Uid_Type = this.state.Buyer_Type;
                    this.CallRetailMgtListData();
                    this.GetTsList();
                }
                else {
                    this.setState({ Title: "등록오류", Content: Data.message });
                    Big3Common.ModalAlert(bootstrap, "MessageAlert");
                }
            }
            catch (e) {
                console.log("handleSave_Click", e);
            }
        }
        else {
            this.setState({ Title: "등록오류", Content: "택배삼촌 정보가 없습니다." });
            Big3Common.ModalAlert(bootstrap, "MessageAlert");
        }

        event.preventDefault();
    }
    //사입 택배 선택
    handleBuyerClick(value) {
        this.setState({
            Buyer_Type: value,
            Buyer_Uid: "",
            Buyer_Org_Name: "",
            Buyer_Name: "",
            Area_Name: ""
        })
    }
    //택배삼촌 탈퇴
    async handleWithdraw_Click(event) {
        try {

            let Data = await Big3Common.Post('api/MyPage/StoreMgr/WithdrawTs', { }, true);
            if (Data.codeName === Big3Common.ResultCode.Success) {
                this.setState({
                    Title: "탈퇴안내",
                    Content: "정상적으로 탈퇴되었습니다.",
                    Buyer_Uid: "",
                    Buyer_Org_Name: "",
                    Buyer_Name: "",
                    Area_Name: ""
                });
                Big3Common.ModalAlert(bootstrap, "MessageAlert");
                Big3Common.WebStorage.RemoveStorage(Big3Common.WebStorage.StorageName.Uid_Type);
                this.Uid_Type = "";
                this.CallRetailMgtListData();
                this.GetTsList();
            }
            else {
                this.setState({ Title: "탈퇴오류", Content: Data.message });
                Big3Common.ModalAlert(bootstrap, "MessageAlert");
            }
        }
        catch (e) {
            console.log("handleDelete_Click", e);
        }
        event.preventDefault();
    }
    Buttonrender() {
        const SsList = this.state.SsList.filter(list => list.appr_status === "01" || list.appr_status === "02" || list.appr_status === "03");
        const TsList = this.state.TsList.filter(list => list.appr_status === "01" || list.appr_status === "02" || list.appr_status === "03");
        
        if (SsList.length > 0 || TsList.length > 0) {
            if (SsList.length > 0 && TsList.length === 0) {
                //사입삼촌 사용자가 승인대기 상태일때 메세지를 알려줌
                const SsList01 = this.state.SsList.find(list => list.appr_status === "01");
                if (SsList01 != null) {
                    return (
                        <div className="clod_info_box">
                            <p className="clod_name">사입삼촌 : {SsList01.org_name }</p>
                            <p className="clod_name">승인상태 : {SsList01.appr_status_nm}</p>
                            <p className="clod_name">사입삼촌이 사입을 수락해주셔야 사입요청이 가능한 상태입니다.</p>
                        </div>
                      
                    )
                }
            }
            else {
                return null;
            }
        }
        else {
            return (
                <div className="b_d_box_wrap">
                    <button className="b_box" onClick={() => this.handleBuyerClick("SS")}>
                        <div className="icon"></div>
                        <div>사입삼촌 등록</div>
                    </button>
                    <button className="d_box" onClick={() => this.handleBuyerClick("TS")}>
                        <div className="icon"></div>
                        <div>택배삼촌 등록</div>
                    </button>
                </div>
            )
        }
        
        
    }
    BuyerInputrender() {
        const SsList = this.state.SsList.filter(list => list.appr_status === "01" || list.appr_status === "02" || list.appr_status === "03" );
        const TsList = this.state.TsList.filter(list => list.appr_status === "01" || list.appr_status === "02" || list.appr_status === "03" );
        if (SsList.length > 0) return false;
        if (TsList.length > 0) return false;

        if (this.state.Buyer_Type === "SS") {
            return (
                <>
                    <div className="buyer_info_box">
                        <div className="txt_box">
                            <ul>
                                <li>동대문 사입삼촌에 주문서가 전달 되고, 상품을 사입삼촌이 배송합니다.</li>
                                <li>사입삼촌 등록 후 등록된 사입자가 승인이후 사입주문이 가능합니다.</li>
                            </ul>
                        </div>
                        <label>사입자찾기</label>
                        <div className="nc_box">
                            <input type="tel"
                                className="form-control"
                                placeholder="사입자 전화번호 검색하기(-는 제외)"
                                id="BuyerPhone"
                                maxLength="11"
                                pattern="\d*"
                                value={this.state.BuyerPhone}
                                onChange={(e) => { this.handle_Change(e, 12); }}
                                onBlur={this.handle_Blur}
                            />
                            <button type="button" className="search_btn" onClick={this.handleBuyerSearch_Click}>검색</button>
                        </div>
                    </div>
                    <div className="buyer_info_box">
                        <p>업체명: {this.state.Buyer_Org_Name}</p>
                        <p>사입자: {this.state.Buyer_Name} {this.state.Area_Name}</p>
                    </div>
                </>
            )
        } else if (this.state.Buyer_Type === "TS") {
            return (
                <>
                    <div className="buyer_info_box">
                        <div className="txt_box">
                            <ul>
                                <li>동대문 택배삼촌에 주문서가  전달이 되고 상품을 택배로 배송해 드립니다.</li>
                                <li>택배삼촌은 별도의 승인 없이 등록 직후 택배배송 주문을 할 수 있습니다.</li>
                            </ul>
                        </div>
                        <label>택배삼촌 찾기</label>
                        <div className="nc_box">
                            <ComboBox id="tscombo"
                                textName="buyer_org_name"
                                valueName="buyer_uid"
                                emptyText="택배삼촌선택하기"
                                optionList={this.state.TsCombo}
                                setValue={this.state.Buyer_Uid}
                                ComboChange={this.handleCombo_Change}
                            />
                        </div>
                    </div>
                    <div className="buyer_info_box">
                        <p>업체명: {this.state.Buyer_Org_Name}</p>
                    </div>
                </>
            )
        }
        
        
    }
    BuyerListrender() {
        const SsList = this.state.SsList.filter(list => list.appr_status === "01" || list.appr_status === "02" || list.appr_status === "03");
        const TsList = this.state.TsList.filter(list => list.appr_status === "01" || list.appr_status === "02" || list.appr_status === "03");

        if (SsList.length !== 0 && this.Uid_Type === "SS") {
            return (
                <div className="buyer_info_box">
                    <div className="title">사입자리스트</div>
                    {
                        SsList.map((list, idx) =>
                            <div className="buyer_list_info" key={idx}>
                                <p>업체명: {list.org_name}</p>
                                <p>사입자: {list.buyer_name} ({list.area_name})</p>
                                <p>상태: {list.appr_status_nm} <span className="a_date">등록일자:{list.reg_dt}</span></p>
                            </div>
                        )
                    }
                </div>
            )
        } else if (TsList.length !== 0 && this.Uid_Type === "TS") {
            return (
                <div className="buyer_info_box">
                    <div className="title">택배삼촌 리스트</div>
                    {
                        TsList.map((list, idx) =>
                            <div className="buyer_list_info" key={idx}>
                                <p>업체명: {list.buyer_org_name}</p>
                                <button className="w_btn" onClick={this.handleWithdraw_Click}>택배삼촌 탈퇴</button>
                            </div>
                        )
                    }
                </div>
            )
        }
        
    }
    render() {
        const Buttonrender = this.Buttonrender();
        const BuyerInputrender = this.BuyerInputrender();
        const BuyerListrender = this.BuyerListrender();
        let CountData = 0;
        if (this.Uid_Type === "SS") {
            CountData = this.state.SsList.filter(list => list.appr_status === "01" || list.appr_status === "02" || list.appr_status === "03").length;
        } else if (this.Uid_Type === "TS") {
            CountData = this.state.TsList.filter(list => list.appr_status === "01" || list.appr_status === "02" || list.appr_status === "03").length;
        }
        return (
            <div>
                <div className="p_b_margin container_box d_padding">
                    {Buttonrender}
                    {BuyerInputrender}
                    {BuyerListrender}
                </div>
                <div className="catagory_button_box">
                    {
                        CountData > 0 ? "" : <button type="button" className="btn_v btn_v1" onClick={this.handleSave_Click }>등록하기</button>
                    }
                </div>
                <Alert
                    id="MessageAlert"
                    title={this.state.Title}
                    content={this.state.Content}                    
                />
            </div>
        );
    }
}
